module.exports = __webpack_public_path__ + "media/icons/time-icon-23431ee8.png";